import { render, staticRenderFns } from "./category-service-select-new.vue?vue&type=template&id=2b48c09e"
import script from "./category-service-select-new.vue?vue&type=script&lang=js"
export * from "./category-service-select-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports